/**
 * Havenwear collection.js - AJAX storefront filtering and sorting.
 * Falls back to full page navigation if a request fails.
 */
(() => {
  'use strict';

  const theme = window.theme;
  const { $, $$, define } = theme.utils;

  class FacetFiltersForm extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.sectionId = this.dataset.sectionId;
      this.form = $('[data-facets-form]', this);
      this.drawer = $('[data-facets-drawer]', this);
      if (!this.form) return;

      const submit = theme.utils.debounce(() => this.render(this.query()), 450);
      this.addEventListener('change', (event) => {
        if (event.target.closest('[data-facets-form]') || event.target.name === 'sort_by') submit();
      });
      this.addEventListener('input', (event) => {
        if (event.target.type === 'number') submit();
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.render(this.query());
      });

      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-facet-remove]');
        if (remove) {
          event.preventDefault();
          this.render(new URL(remove.href, window.location.origin).searchParams.toString());
          return;
        }
        const open = event.target.closest('[data-facets-open]');
        if (open) {
          this.openDrawer(open);
          return;
        }
        if (event.target.closest('[data-facets-close]')) this.closeDrawer();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-open')) {
          event.stopPropagation();
          this.closeDrawer();
        }
      });

      this.onPopState = () => this.render(window.location.search.slice(1), false);
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }

    query() {
      const params = new URLSearchParams();
      new FormData(this.form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
      return params.toString();
    }

    async render(query, pushState = true) {
      const results = document.getElementById(`ProductGrid-${this.sectionId}`);
      if (results) results.classList.add('is-loading');
      const separator = query ? '&' : '';
      const url = `${window.location.pathname}?section_id=${encodeURIComponent(this.sectionId)}${separator}${query}`;
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(String(response.status));
        const doc = theme.utils.parseHTML(await response.text());
        const freshResults = doc.getElementById(`ProductGrid-${this.sectionId}`);
        if (freshResults && results) results.innerHTML = freshResults.innerHTML;
        const freshForm = doc.querySelector(`facet-filters-form[data-section-id="${this.sectionId}"]`);
        if (freshForm) this.patch(freshForm);
        if (pushState) window.history.pushState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
      } catch (error) {
        window.location.href = `${window.location.pathname}${query ? `?${query}` : ''}`;
      } finally {
        if (results) results.classList.remove('is-loading');
      }
    }

    patch(fresh) {
      ['[data-facets-count]', '.facets__open', '.facets__footer'].forEach((selector) => {
        const current = $(selector, this);
        const next = $(selector, fresh);
        if (current && next) current.innerHTML = next.innerHTML;
      });

      const currentActive = $('.facets__active', this);
      const freshActive = $('.facets__active', fresh);
      if (currentActive && freshActive) currentActive.replaceWith(freshActive);
      else if (currentActive) currentActive.remove();
      else if (freshActive) {
        const bar = $('.facets__bar', this);
        if (bar) bar.after(freshActive);
      }

      const currentFacets = $$('details.facet', this);
      const freshFacets = $$('details.facet', fresh);
      freshFacets.forEach((freshDetails, index) => {
        const currentDetails = currentFacets[index];
        if (!currentDetails) return;
        if (currentDetails.contains(document.activeElement)) {
          $$('.facet__option', freshDetails).forEach((freshOption, optionIndex) => {
            const currentOption = $$('.facet__option', currentDetails)[optionIndex];
            if (!currentOption) return;
            currentOption.classList.toggle('is-disabled', freshOption.classList.contains('is-disabled'));
            const freshCount = $('.facet__count', freshOption);
            const currentCount = $('.facet__count', currentOption);
            if (freshCount && currentCount) currentCount.textContent = freshCount.textContent;
            const freshInput = $('input', freshOption);
            const currentInput = $('input', currentOption);
            if (freshInput && currentInput) currentInput.disabled = freshInput.disabled;
          });
        } else {
          freshDetails.open = currentDetails.open;
          currentDetails.replaceWith(freshDetails);
        }
      });
    }

    openDrawer(opener) {
      if (!this.drawer) return;
      this.opener = opener;
      this.drawer.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      theme.scrollLock.lock();
      const panel = $('.drawer__panel', this.drawer);
      window.setTimeout(() => theme.a11y.focusInto(panel, panel), 50);
    }

    closeDrawer() {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      theme.scrollLock.unlock();
      theme.a11y.releaseFocus();
      if (this.opener) {
        this.opener.setAttribute('aria-expanded', 'false');
        this.opener.focus({ preventScroll: true });
      }
    }
  }

  define('facet-filters-form', FacetFiltersForm);
})();
